import {Button} from "../../../../../shadCn/components/ui/button";
import React from "react";

function DailyCheckChildren({clicked = false, children, setChildren, view = false}){

    function addChildren(){
        setChildren([...children, {name : "", type : "INPUT", confirm : "", standard : ""}]);
    }

    function removeChildren(index){
        const newChildren = children.filter((_, i) => i !== index);
        setChildren(newChildren); // 특정 인덱스의 children 요소 제거
    }

    const handleInputChange = (e, index, field) => {
        const newTitle = e.target.value;
        setChildren((prevChildren) => {
            const updatedChildren = [...prevChildren]; // 기존 배열을 복사
            updatedChildren[index] = {
                ...updatedChildren[index], // 기존 객체를 복사
                [field] : newTitle
            };
            return updatedChildren;
        });
    };

    return(
        <>
            <div>
            {!view ? <Button clicked={false} type="button" variant="outline" onClick={addChildren}>추가</Button> : ""}
            {
                children.map((each, index) => {
                    return(
                        <div className={"mt-1 flex"} key={index}>
                            {!view ?
                                <>
                                    <button className={"inline-flex items-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-[28px] px-4"}
                                            onClick={()=>removeChildren(index)}>제거</button>
                                    <div className={"ml-[5px]"}>
                                        체크항목 : <input type={"text"} className={"basic-input focus w-[300px] ml-[5px]"} value={children[index].name} onChange={(e) => handleInputChange(e, index, "name")} />
                                    </div>
                                    <div className={"ml-[5px]"}>
                                        체크방법 : <input type={"text"} className={"basic-input focus w-[400px] ml-[5px]"} value={children[index].confirm} onChange={(e) => handleInputChange(e, index, "confirm")} />
                                    </div>
                                    <div className={"ml-[5px]"}>
                                        기준&권장값 : <input type={"text"} className={"basic-input focus w-[400px] ml-[5px]"} value={children[index].standard} onChange={(e) => handleInputChange(e, index, "standard")} />
                                    </div>
                                </>
                                :
                                <>
                                    <span className={"w-[300px] ml-[5px]"} >체크항목 : {each.name}</span>
                                    <span className={"w-[300px] ml-[5px]"} >체크방법 : {each.confirm}</span>
                                    <span className={"w-[300px] ml-[5px]"} >기준 & 권장값 : {each.standard}</span>
                                </>
                            }
                        </div>
                    )
                })
            }
            </div>
        </>
    )
}

export {DailyCheckChildren}